module.exports = __webpack_public_path__ + "static/media/17.L-Box.5e629985.webp";